import TagArrayInputField from "@/components/forms/TagArrayInputField.tsx";
import CollapsibleFormSection from "@/components/forms/CollapsibleFormSection.tsx";
import {useFormContext, useWatch} from "react-hook-form";
import {CharacterFormInput} from "@/characters/admin/form/CharacterFormSchema.ts";
import CharacterSensesForm from "./CharacterSensesForm.tsx";

export default function CharacterCapabilitiesForm() {
    const {control, formState: {errors}} = useFormContext<CharacterFormInput>();
    const [skills, senses, languages] = useWatch({control, name: ["skills", "senses", "languages"]});
    const count = skills.length + senses.specialSenses.length
        + (senses.passivePerception === null ? 0 : 1) + languages.length;
    const hasErrors = Boolean(errors.skills || errors.senses || errors.languages);

    return <CollapsibleFormSection title="Kenntnisse & Wahrnehmung"
                                   summary={count === 0 ? "Keine Einträge" : `${count} Einträge`}
                                   forceOpen={hasErrors}
                                   contentClassName="grid gap-3 md:grid-cols-2 xl:grid-cols-3">
            <TagArrayInputField name="skills" title="Fertigkeiten"/>
            <CharacterSensesForm/>
            <TagArrayInputField name="languages" title="Sprachen"/>
    </CollapsibleFormSection>;
}
